import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
// const injectTapEventPlugin = require('react-tap-event-plugin');
// injectTapEventPlugin();

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js